import PropTypes from 'prop-types'
import React, { Component } from 'react'

import style from './style.scss'

/**
 * Designed to be nested inside of an Overlay (like Popover & Tooltip) but uses
 * fixed positioning and anchors the content to one side of the page.
 *
 * None of the props should be supplied directly, simply set "placement" on
 * the Overlay and "animation" to Collapse if you want it to slide in rather
 * than fade.  (Note that Collapse only works vertically, a custom animation
 * would be required to slide in if the position is 'right' or 'left')
 */
export default class ToolbarOverlay extends Component {
    static propTypes = {
        arrowOffsetLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        arrowOffsetTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        children: PropTypes.node,
        className: PropTypes.string,
        placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
        positionLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        positionTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        style: PropTypes.object
    }

    constructor(props){
        super(props)
    }

    render() {
         /* eslint-disable no-unused-vars */
        const {
            arrowOffsetLeft,
            arrowOffsetTop,
            children,
            className,
            placement,
            positionLeft,
            positionTop,
            style: elementStyle,
            ...otherProps
        } = this.props
        /* eslint-enable no-unused-vars */

        let containerClass = style.container
        if (className) {
            containerClass += ' ' + className
        }

        const containerStyle = {}

        switch (placement) {
            case 'top':
                containerStyle.bottom = 'auto'
                break
            case 'right':
                containerStyle.left = 'auto'
                break
            default:
            case 'bottom':
                containerStyle.top = 'auto'
                break
            case 'left':
                containerStyle.right = 'auto'
                break
        }

        return (
            <div className={containerClass} style={containerStyle} {...otherProps}>{children}</div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/toolbar-overlay/index.js